import React,{useMemo} from 'react';
import { Typography, Grid } from '@mui/material';
import Chart from '../../Home/components/Chart';
import './DashboardCard.css';



export const isValidNumber = (v) =>
  v !== null && v !== undefined && !isNaN(v);

export const formatAcumulador = (valor) => {
  if (!isValidNumber(valor) || valor < 0) {
    return { value: "--", unit: "" };
  }

  const num = Number(valor);

  if (num >= 100000) {
    // toneladas
    return {
      value: (num / 1000).toFixed(2),
      unit: "Ton O₂",
    };
  }

  if (num >= 1000) {
    return {
      value: Math.floor(num).toLocaleString("es-CL"),
      unit: "kg O₂",
    };
  }

  return {
    value: num.toFixed(2),
    unit: "kg O₂",
  };
};

const DashboardCard = ({ title, centerCode, data, visible, onToggle, translate }) => {
  const t = typeof translate === "function" ? translate : (key) => key;
  const sensorKey = centerCode.toLowerCase();
  const sensor = data?.sensor_data?.[sensorKey];

  const safeVisible = visible || {
    cumulant: true,
    flow_rate: true,
  };

  const chartData = useMemo(() => {
    if (
      !sensor ||
      !Array.isArray(sensor.TS) ||
      !Array.isArray(sensor.cumulant) ||
      !Array.isArray(sensor.flow_rate)
    ) {
      return [];
    }

    return sensor.TS.map((ts, i) => ({
      TS: ts,
      cumulant: Number(sensor.cumulant[i]),
      flow_rate: Number(sensor.flow_rate[i]),
      connection_status: Boolean(sensor.connection_status?.[i]),
    }));
  }, [sensor]);

  const lastValues = useMemo(() => {
    if (!chartData.length) return null;
    return chartData[chartData.length - 1];
  }, [chartData]);

  const minutesAgo = lastValues
    ? Math.round((Date.now() - new Date(lastValues.TS)) / 60000)
    : null;

  /* ⛔️ return condicional DESPUÉS de los hooks */
  if (!chartData.length) {
    return (
      <div className="dashboard-card empty">
        <Typography variant="caption">
          {t("no_data")}
        </Typography>
      </div>
    );
  }


const acumuladorFormatted = formatAcumulador(lastValues?.cumulant);



  return (
    <div className="dashboard-card" sx={{ cursor: 'move', mb: 1 }}>
      <div className="dashboard-card-header drag-handle">
        <Typography variant="subtitle1">{title}</Typography>
          {lastValues && (
            <div className="dashboard-status">
              <span
                className={`status-dot-dash ${
                  lastValues.connection_status ? 'status-ok-dash' : 'status-error-dash'
                }`}
              />
              <Typography variant="caption">
                {t("last_reading_ago_minutes", { minutesAgo })}
              </Typography>
            </div>
          )}
      </div>

      <div className="dashboard-card-chart">
        <Chart data={chartData} visible={safeVisible} compact translate={translate} />
      </div>

      <div className="divider-soft" />

      <div className="dashboard-card-metrics">
        <Grid container spacing={1} justifyContent="space-around">
          <Grid item>
            <div
              className={`metric ${safeVisible.cumulant ? 'active' : 'inactive'}`}
              onClick={() => onToggle(centerCode, 'cumulant')}
            >
              <Typography variant="caption">{t("o2_cumulative")} [ {acumuladorFormatted.unit} ]</Typography>
              <Typography variant="subtitle1" color="#22c55e">
                {/* {Number(sensor.cumulant[lastIndex]).toFixed(2)} */}
                {lastValues?.cumulant != null && lastValues.cumulant >= 0
                ? lastValues.cumulant.toFixed(2)
                : "--"}
              </Typography>
            </div>
          </Grid>

          <Grid item>
            <div
              className={`metric ${safeVisible.flow_rate ? 'active' : 'inactive'}`}
              onClick={() => onToggle(centerCode, 'flow_rate')}
            >
              <Typography variant="caption">{t("o2_instantaneous")} [ g/min ]</Typography>
              <Typography variant="subtitle1" color="#3b82f6">
                {/* {Number(sensor.flow_rate[lastIndex]).toFixed(2)} */}
                  {lastValues?.flow_rate != null && lastValues.flow_rate >= 0
                  ? lastValues.flow_rate.toFixed(2)
                  : "--"}
              </Typography>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default DashboardCard;
